<a class="image-container"
  [ngClass]="{'active-border' : active, 'disabled' : absent, 'off' : off, 'no-artwork' : character.noThumbnail || !settingsManager.settings.artwork, 'modern': settingsManager.settings.theme == 'modern'}"
  [style.--ghs-character-color]="character.color"
  [ghs-label]="(gameManager.game.state == GameState.next ? (active ? 'game.figure.endTurn' : 'game.figure.startTurn') : 'game.figure.setInitiative')"
  [ghs-label-attribute]="'title'">
  <img class="image"
    [src]="character.noThumbnail || !settingsManager.settings.artwork ? character.iconUrl : characterManager.characterThumbnail(character)" />
  <ghs-healthbar [entity]="character"></ghs-healthbar>
</a>